import { render, staticRenderFns } from "./categoryView.vue?vue&type=template&id=06c8b570&scoped=true"
import script from "./categoryView.vue?vue&type=script&lang=js"
export * from "./categoryView.vue?vue&type=script&lang=js"
import style0 from "./categoryView.vue?vue&type=style&index=0&id=06c8b570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c8b570",
  null
  
)

export default component.exports